/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Where_InstanceInputs */

const en_adm_where_instance = /** @type {(inputs: Adm_Where_InstanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the whole instance`)
};

const de_adm_where_instance = /** @type {(inputs: Adm_Where_InstanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`die ganze Instanz`)
};

/**
* | output |
* | --- |
* | "the whole instance" |
*
* @param {Adm_Where_InstanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_where_instance = /** @type {((inputs?: Adm_Where_InstanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Where_InstanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_where_instance(inputs)
	return en_adm_where_instance(inputs)
});